import React from 'react';
import CopyToClipboardButton from "../../Components/copyToClipboardButton";
import { Link as PolarisLink, SpaceBetween } from '@amzn/awsui-components-react/polaris';
import {Box} from "@amzn/awsui-components-react";

interface ControlPlaneAndDataPlaneAccountIsenLinksProps {
    account: string;
    readOnlyLink: string;
    supportOpsReadOnlyLink: string;
    readOnlyLinkText?: string;
    supportOpsReadOnlyLinkText?: string;
}

const AmazonMqBrokerAccountIsenLinks: React.FC<ControlPlaneAndDataPlaneAccountIsenLinksProps> = ({
    account,
    readOnlyLink,
    supportOpsReadOnlyLink,
    readOnlyLinkText = 'AMQ ReadOnly',
    supportOpsReadOnlyLinkText = 'SupportOps',
}) => {
    return (
        <SpaceBetween direction="vertical" size="xxs">
            <Box>{account}</Box>
            <SpaceBetween direction="horizontal" size="xs">
                <SpaceBetween direction="horizontal" size="xxxs" alignItems="center">
                    <PolarisLink href={readOnlyLink} target="_blank">{readOnlyLinkText}</PolarisLink>
                    <CopyToClipboardButton text={readOnlyLink} textDescription={`${readOnlyLinkText} link`}/>
                </SpaceBetween>
                <SpaceBetween direction="horizontal" size="xxxs" alignItems="center">
                    <PolarisLink href={supportOpsReadOnlyLink} target="_blank">{supportOpsReadOnlyLinkText}</PolarisLink>
                    <CopyToClipboardButton text={supportOpsReadOnlyLink} textDescription={`${supportOpsReadOnlyLinkText} link`}/>
                </SpaceBetween>
            </SpaceBetween>
        </SpaceBetween>
    );
};

export default AmazonMqBrokerAccountIsenLinks;

